const init = () => {
  $('#clearCacheLink').on('click', () => {
    $.ajax({
      url: '/apiCache/clearAll',
      dataType: 'jsonp',
      success: (res) => {
        console.log(res);
      }
    })
  });
};
module.exports = {init};